import React from 'react';
import styled from 'styled-components';
import { NamedColorsHEX } from '../util/styles';

const ScFooter = styled.footer`
  display: flex;
  flex-direction: column;
  background-color: ${NamedColorsHEX.LightSeaTurquoise};

  h1 {
    margin: 5px 0;
  }
`;

export const Footer = () => {
  return (
    <ScFooter className="babys-page-padding">
      <p>
        Feito com{' '}
        <span role="img" aria-label="amor">
          ❤️
        </span>{' '}
        por {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <a href="https://celsoneto.com.br" target="_blank">
          Celso Neto.
        </a>
      </p>
    </ScFooter>
  );
};
